import React from 'react';

const CategoryItems = (props) => {
    const {
        items,
    } = props;

    let categoriesTag = items.map((category, index) => {
        let nameCat = category.name.replace(/&amp;/g, "&");
        return (
          <a 
            key={category.id}
            onClick={() => {replaceSelected(category.id, category.taxonomy)}} href={category.link}
          ><span className="single-article-cat">{nameCat}</span></a>
        );
      });

    return categoriesTag;
}

export default CategoryItems;